import { useState, type ReactNode } from "react";
import { Label } from "@osago/ui";

interface AccordionSectionProps {
  title: string;
  defaultOpen?: boolean;
  action?: ReactNode;
  children: ReactNode;
}

export function AccordionSection({
  title,
  defaultOpen = false,
  action,
  children,
}: AccordionSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="border-b border-input-border pb-4 last:border-b-0 last:pb-0">
      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex flex-1 items-center gap-2 text-left"
          aria-expanded={open}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`h-4 w-4 shrink-0 text-label-text transition-transform duration-200 ${
              open ? "rotate-90" : ""
            }`}
          >
            <path d="M9 6l6 6-6 6" />
          </svg>
          <Label variant="section" as="span">
            {title}
          </Label>
        </button>
        {open && action}
      </div>
      {open && <div className="mt-3">{children}</div>}
    </section>
  );
}
